angular.module('elfium').filter('elfiumSQLDate', ['dateFilter', function (dateFilter) {
    return function (date) {
        return dateFilter(date, 'yyyy-MM-dd');
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumSQLDateFilter.ts